<script lang="ts" setup>
import { Popup, showSuccessToast } from "vant";
import { computed, ref } from "vue";
import { GAL_GAME_URL_PREFIX } from "@/stores/galGameEditor";
import { ApiBuildGalGame } from "@/apis/gal-game";
import { copyToClipboard } from "@/modules/common";
import i18n from "@/locales";

interface FastForwardParams {
  dialogId?: number;
  nodeId: number;
}

// Props
const props = defineProps<{
  id: number;
  uuid: string; // galgame.uuid
}>();

// States
const show = ref(false);
const fastForward = ref<null | FastForwardParams>(null); // galgame.dialogId
const url = computed(() => {
  const baseUrl = `${GAL_GAME_URL_PREFIX}?uuid=${props.uuid}&preview=true`;
  if (fastForward.value) {
    const { dialogId, nodeId } = fastForward.value;
    let fullUrl = `${baseUrl}&nodeId=${nodeId}`;
    if (dialogId) {
      fullUrl += `&dialogId=${dialogId}`;
    }
    return fullUrl;
  } else {
    return baseUrl;
  }
});
const mute = computed(() => (show.value ? "autoplay" : "autoplay;muted"));

// Lifecycle

// Methods
const startPreview = async (params?: FastForwardParams) => {
  await ApiBuildGalGame(props.id);
  if (params) {
    fastForward.value = params;
  } else {
    fastForward.value = null;
  }
  show.value = true;
};
// Emit
defineExpose({
  startPreview,
});

export interface GalGamePreviewPopupInstance {
  startPreview: typeof startPreview;
}

const clickCopy = async () => {
  copyToClipboard(`${GAL_GAME_URL_PREFIX}?uuid=${props.uuid}&preview=true`);
  showSuccessToast({ message: i18n.global.t("Message.copySuccessful") });
};
</script>
<template>
  <popup
    v-if="show"
    v-model:show="show"
    class="flex flex-col items-center gap-2 h-[90%] galgame-preview-popup pt-2"
    position="bottom"
    round
  >
    <button class="btn btn-sm rounded" @click="clickCopy">
      {{ $t("Buttons.copyPlayLink") }}
    </button>
    <iframe
      :src="show ? url : 'about:blank'"
      class="w-full h-full overflow-hidden"
    />
  </popup>
</template>
<style>
.van-popup.van-popup--bottom.galgame-preview-popup {
  width: 100%;
  max-width: 100%;
}
</style>
